import React from 'react';

export const dragInitData = {
  isDragging: false,
};

export const DragContext = React.createContext(
  dragInitData // default value
);
